import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(24, 27),
    marginBottom: theme.spacing(10),
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    height: 'min-content',
  },
  linkText: {
    fontSize: 22,
    color: theme.palette.common.black,
    // paddingRight: theme.spacing(7.5),
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 0 0 ${theme.spacing(7.5)}px` : `0 ${theme.spacing(7.5)}px 0 0`,
  },
}));
